// Render-engine abstraction seam (Local Engine Phase 1).
// The editor should eventually call renderProject(project) instead of depending on
// FFmpeg directly. For now this ALWAYS delegates to the existing server FFmpeg
// renderer (via the caller's api.createExport) — the local WebCodecs/WebGPU path is
// in beta and intentionally NOT wired into production export yet. This module gives
// future phases a single place to add LocalWebCodecsRenderer / LocalWebGPUComposer /
// LocalFFmpegWasmRenderer without touching the editor.

import { detectCapabilities, summarize } from "./capabilities";

export const RENDER_PATHS = {
  SERVER_FFMPEG: "server-ffmpeg",
  LOCAL_WEBCODECS: "local-webcodecs",
  LOCAL_WEBGPU: "local-webgpu",
  LOCAL_FFMPEG_WASM: "local-ffmpeg-wasm",
};

let _capsCache = null;

export async function getCapabilities(force = false) {
  if (_capsCache && !force) return _capsCache;
  _capsCache = await detectCapabilities();
  return _capsCache;
}

// Decide which renderer to use. Currently always server; the local path is reported
// as "available (beta)" when the device supports it so the UI can surface readiness.
export async function chooseRenderPath() {
  const caps = await getCapabilities();
  const s = summarize(caps);
  return {
    path: RENDER_PATHS.SERVER_FFMPEG,
    localAvailable: s.localCapable,
    reason: s.reason,
    caps,
  };
}

// Single entry point the editor can call. `serverExport` is injected by the caller
// (Editor/ExportModal) so this module has no hard dependency on the api client.
export async function renderProject({ serverExport }) {
  const decision = await chooseRenderPath();
  // Only the server path is production-ready today.
  if (typeof serverExport !== "function") {
    throw new Error("No server export function provided to renderProject.");
  }
  const result = await serverExport();
  return { path: decision.path, localAvailable: decision.localAvailable, result };
}
